<template>
  <div class="search">
    <div class="main">
      <div class="search-box">
        <div class="search-input">
          <input type="search" v-model="keyword" placeholder="搜索商家、商品名称" @keydown="key($event)">
          <span class="clearbtn" v-if=" keyword!='' " @click="clearInput"></span>
        </div>
        <span class="btn" @click="getGoodsSearch()">搜索</span>
      </div>
      <div class="search-result" v-if="!showResult">
        <div class="icon icon-hot" v-if="historySearchList.length>0">历史搜索 <span class="icon icon-delete fr" @click="clearHistory()"></span></div>
        <div class="hot-keys" v-if="historySearchList.length>0">
          <a href="javascript:void(0);" @click="getGoodsSearch(item)" v-for="item in historySearchList">{{item}}</a>
        </div>
        <div class="icon-hot" style="margin-top: .4rem;margin-bottom: .04rem;">搜索发现</div>
        <div class="hot-keys" v-if="searchRecom.length>0">
          <a href="javascript:void(0);" @click="getGoodsSearch(item.keyword)" v-for="item in searchRecom">{{item.keyword}}</a>
        </div>
        <div class="shop-head">
          <div v-for="item in shopRecom" class="shop-recom" @click="toGoodsList(item.shop_id)">
            <img class="recom-img" :src="item.pic" alt="">
            <div>
              <div class="ellipse recom-name">{{item.shop_name}}</div>
              <div class="recom-type">{{item.type_name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="goods-list search-goods">
        <div v-if="showResult">
          <ul v-if="goodsInfo.length>0">
            <li v-for="item in goodsInfo">
              <div class="goods-box">
                <a>
                  <div class="goods-img"  @click="toGoodsList(item.id,item.shop_name)">
                    <div class="lazy goodimg" :style="{backgroundImage: 'url('+ item.pic +')'}"></div>
                  </div>
                  <div class="goods-des"  @click="toGoodsList(item.id,item.shop_name)">
                    <div class="name ellipse" v-html="item.shop_name"></div>
                    <div class="comment" style="margin-top:0.03rem">
                      <CommentStars :qualityCode="item.score"></CommentStars>
                      <span>{{item.score}}</span>
                      <span style="color: #E3E3E3">|</span>
                      <span>月售 {{item.sales_append}}单</span>
                    </div>
                    <div class="flex-row-bc">
                      <div class="flex-row-sc">
                        <span>起送 ￥{{item.threshold_amount}}</span>
                        <span style="color: #E3E3E3;padding: 0 0.05rem">|</span>
                        <span v-if="item.delivery_fee_text">{{item.delivery_fee_text}}</span>
                        <template v-else>
                          <span>配送￥</span>
                          <span v-if="item.new_delivery_fee || item.new_delivery_fee === 0">{{item.new_delivery_fee}}</span>
                          <span v-else>{{ item.delivery_fee }}</span>
                          <span v-if="item.is_many_delivery == 1">起</span>
                        </template>
                        <template v-if="item.new_delivery_fee || item.new_delivery_fee === 0">
                          <span style="color: #999;text-decoration: line-through;margin-right:0">￥{{item.delivery_fee}}</span>
                        </template>
<!--                        <div v-if="item.new_delivery_fee || item.new_delivery_fee === 0">-->
<!--                          <span style="margin-right: 0">配送￥{{item.new_delivery_fee}}</span>-->
<!--                          <span v-if="item.is_many_delivery == 1">起</span>-->
<!--                          <span style="color: #999;text-decoration: line-through;margin-right:0">￥{{item.delivery_fee}}</span>-->
<!--                        </div>-->
<!--                        <div v-else>-->
<!--                          <span style="margin-right: 0">配送￥{{item.delivery_fee}}</span>-->
<!--                          <span v-if="item.is_many_delivery == 1">起</span>-->
<!--                        </div>-->
                        <span v-if="item.delivery_type == 1">(商家配送)</span>
                      </div>
                      <div v-if="item.dinnerDuration">{{item.dinnerDuration}}</div>
                    </div>
                  </div>
                  <!--店铺副标题、准时达-->
                  <div class="flex-row-bc">
                    <div class="vice_title" v-if="item.vice_title" style="margin: 0 0 0 .2rem">{{ item.vice_title }}</div>
                    <div class="punctual-arrive" v-if="item.zsd">{{item.zsd}}</div>
                  </div>
                  <div class="promotion_reduce" v-if="item.promotion_reduce && item.promotion_reduce.reduce_info">
                    <span v-for="item2 in item.promotion_reduce.reduce_info" class="promotion_reduce-type border">{{item2.meet_price}}减{{item2.cut_price}}</span>
                    <!--<span class="promotion_reduce-type border">满20减7</span>-->
                    <!--<span class="promotion_reduce-type border">满30减12</span>-->
                  </div>
                  <!--店铺优惠券-->
                  <div class="promotion-and-coupon">
                    <div class="promotion" v-if="item.promotion_list && item.promotion_list.length > 0">
                      <img class="icon" v-for="pro in item.promotion_list" :src="pro.icon_url" width="100%" >
                    </div>
                    <div class="package" v-if="item.promotion_package && item.promotion_package.length > 0">
                      <span v-for="(proPackage,index5) in item.promotion_package" :key="index5">{{proPackage.package_desc}}</span>
                    </div>
                    <div class="coupon" v-if="item.coupon_list && item.coupon_list.length > 0">
                      <span class="desc" v-for="(coupon,index6) in item.coupon_list" :key="index6">{{ coupon.couponDes }}</span>
                      <span class="get">领券</span>
                    </div>
                  </div>
                  <div class="related-goods" v-if="item.goods_list.length>0">
                    <div class="more-goods" v-if="item.isShowAll">
                      <a v-for="item2 in item.goods_list" v-html="item2.name"></a>
                    </div>
                    <div class="more-goods" v-else>
                      <a @click="toGoodsList(item.id)" v-html="item.goods_list[0].name"></a>
                    </div>
                    <div v-if="item.goods_list.length>1">
                      <span @click="toggleShowMore(item)" class="shield-more" v-if="item.isShowAll">收起</span>
                      <span @click="toggleShowMore(item)" class="show-more" v-else>展开其他{{item.goods_list.length-1}}个商品</span>
                    </div>
                  </div>
                  <span v-if="item.is_open == 1 && item.is_book == 0" class="shop-status">营业中</span>
                  <span v-else-if="item.is_open == 1 && item.is_book == 1" class="shop-status can-reserve">可预订</span>
                  <span class="shop-status close" v-else>已打烊</span>
                  <div class="shop-type-box">
                    <span class="shop-type border" v-if="item.is_self_take_new == 1">自提</span>
                    <span class="shop-type border" v-if="item.is_take_out == 1">外送</span>
                    <span class="shop-type eat-in border" v-if="item.is_eat_in == 1">堂食</span>
                  </div>
                </a>
              </div>
            </li>
            <div class="end-line"><span>- end -</span></div>
          </ul>
          <div class="no-info" v-else>
            <div class="no-goods">
              <img src="../assets/images/empty-01.png" />
              <p style="margin: 0.2rem 0">抱歉，未能找到您搜索的商家或商品</p>
              <p style="margin: 0.2rem 0">换个关键词试试吧</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  import CommentStars from '../components/CommentStars'
  import _ from "lodash";
  // import { MessageBox } from 'mint-ui';

  export default {
    name: 'search',
    data () {
      return {
        keyword: '',
        goodsInfo: [],
        showResult: false,
        historySearchList: [],
        searchRecom: [],
        shopRecom: [],
        remSize: 0,
        clientHeight: 0,
      }
    },
    beforeRouteLeave(to, from, next) {
      if (to.name == 'TagPage') {
        to.meta.isUseCache = true
      }
      next()
    },
    created () {
      var _this = this;
      // document.title = '搜索';
      if(window.localStorage.getItem('historySearchList')) {
        _this.historySearchList = JSON.parse(window.localStorage.getItem('historySearchList'))
      } else {
        _this.historySearchList = []
      }
      _this.getSearchRecom();
      _this.getShopRecom();
    },
    mounted() {
      this.clientHeight = document.documentElement.clientHeight;
      let html = document.getElementsByTagName('html');
      if (html[0]) {
        let rem = html[0].style.fontSize;
        this.remSize = parseInt(rem);
      }
    },
    watch: {
      keyword: {
        handler: function (val) {
          var _this = this
          if(val=='') {
            _this.showResult = false
          }
        },
        deep:true
      }
    },
    methods: {
      showMoreGift: function (item) {
        item.iShowMore = !item.iShowMore;
      },
      key: function(e){
        var _this=this;
        if(e.keyCode == '13'){
          // console.log(_this.keyword)
          _this.getGoodsSearch(_this.keyword);
        }
      },
      toggleShowMore: function (item) {
        var _this = this
        for(var key in _this.goodsInfo) {
          if(_this.goodsInfo[key].id == item.id) {
            _this.goodsInfo[key].isShowAll = !_this.goodsInfo[key].isShowAll
          }
        }
      },
      getGoodsSearch: function (e) {
        var _this = this
        var school_id = _this.$store.state.schoolInfo.schoolId
        if(e) {
          _this.keyword = e
        }
        var params = {
          keyword: _this.keyword,
          page: '1',
          page_size: '30',
          school_id: school_id
        }
        actions.getGoodsSearch(_this, params, function (data) {
          for(var key in data) {
            data[key].isShowAll = false;
            data[key].iShowMore = false;
            // 替换搜索商品关键字
            if(data[key].goods_list.length>0) {
              var goodsList = data[key].goods_list;
              for(var m in goodsList) {
                if(goodsList[m].name.indexOf(_this.keyword)>=0) {
                  goodsList[m].name = goodsList[m].name.replace(_this.keyword,'<span class="red">'+_this.keyword+'</span>');
                }
              }
            }
            // 替换搜索店铺名关键字
            if(data[key].shop_name.indexOf(_this.keyword)>=0) {
              data[key].shop_name = data[key].shop_name.replace(_this.keyword,'<span class="red">'+_this.keyword+'</span>');
            }
            if(data[key].promotion_list && data[key].promotion_list.length > 0){
              data[key].promotion_list = _.uniqBy(data[key].promotion_list, item => item.promotion_type);
            }
          }
          // console.log(data);
          _this.goodsInfo = data;
          _this.showResult = true;
          if(_this.keyword.replace(/\s+/g, "") != '') {
            if(_this.historySearchList.indexOf(_this.keyword)<0) {
              _this.historySearchList.unshift(_this.keyword)
            }
            if(_this.historySearchList.length>10) {
              _this.historySearchList = _this.historySearchList.slice(0,9)
            }
          }
          window.localStorage.setItem('historySearchList', JSON.stringify(_this.historySearchList));

          _this.$nextTick(() => {
            let goodsList = document.getElementsByClassName('goods-list');
            let uid = localStorage.getItem('wxUid');
            if (uid && goodsList && goodsList[0] &&  _this.goodsInfo &&  _this.goodsInfo.length > 0) {
              let endLine = document.getElementsByClassName('end-line');
              endLine = (endLine && endLine[0]) ? endLine[0].clientHeight : 0;
              let item = (goodsList[0].clientHeight - endLine - _this.remSize * 0.4)/_this.goodsInfo.length;
              let size = Math.round((_this.clientHeight - _this.remSize * 0.88)/item);
              _this.$store.commit('changeRecordItemHeight', item);
              _this.$store.commit('changeRecordList', _this.goodsInfo);
              _this.$store.commit('changeRecordOtherHeight', (endLine + _this.remSize * 0.88));
              _this.$store.commit('changeRecordPage', 'Search');
              _this.$store.commit('changeRecordState', true);
              _this.$utils.firstLogPush(size, _this.goodsInfo,'asa_merc_shop_search', 'id')
            }
          })
        }, function (data) {
          _this.$messagebox.alert(data.body.message, '');
        })
      },
      toGoodsList: function (data){
        var _this = this;
        var obj = {
          shop_code: data,
          showBlockType: 'orderDishes'
        };
        _this.$store.commit('changeState', obj);
        _this.$router.push({ name: 'GoodsList' })
      },
      clearInput: function (){
        this.keyword = '';
        let uid = localStorage.getItem('wxUid');
        if (uid) {
          let data = this.shopRecom;
          let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
          exposureLog = exposureLog ? exposureLog : [];
          for(let k=0;k<data.length;k++) {
            exposureLog.push({
              uid: uid == 'undefined'?0:uid,
              firstValue: k,
              // shopid: data[k].shop_id,
              refId: data[k].shop_id,
              createTime: new Date().getTime(),
              code: 'asa_merc_shop_recommend',
            })
          }
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      },
      clearHistory: function () {
        var _this = this
        if(_this.historySearchList.length > 0){
          _this.$messagebox.confirm('确定要清空搜索历史？','').then(function(action) {
            _this.historySearchList = [];
            window.localStorage.setItem('historySearchList',[])
          });
        }
      },
      //搜索发现关键词
      getSearchRecom: function () {
        let _this = this;
        actions.getSearchRecom(_this, {school_id: _this.$store.state.schoolInfo.schoolId}, function (data) {
            _this.searchRecom = data
        })

      },
      //搜索店铺推荐
      getShopRecom: function () {
        let _this = this;
        let params = {
          school_id: _this.$store.state.schoolInfo.schoolId,
          login_token: _this.$store.state.wxLoginToken
        }
        actions.getShopRecom(_this, params, function (data) {
          _this.shopRecom = data;
          let uid = localStorage.getItem('wxUid');
          // if (uid) {
            let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
            exposureLog = exposureLog ? exposureLog : [];
            for(let k=0;k<data.length;k++) {
              exposureLog.push({
                uid: uid == 'undefined'?0:uid,
                firstValue: k,
                // shopid: data[k].shop_id,
                refId: data[k].shop_id,
                createTime: new Date().getTime(),
                code: 'asa_merc_shop_recommend',
              })
            }
            localStorage.setItem('lastLogTime', new Date().getTime());
            localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
          // }
        })
      }
    },
    components: {
      CommentStars
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?2106dcce